export default "__VITE_ASSET__X$yzZUdj__"